import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { DEFAULT_CHARACTER_NAME } from "../lib/characterName";
import { logError } from "../lib/errors";
import { pickStringByPaths } from "../lib/path";

export function useCurrentCharacterName() {
  const [characterName, setCharacterName] = useState(DEFAULT_CHARACTER_NAME);

  useEffect(() => {
    let active = true;

    (async () => {
      try {
        const user = await api.getUser();
        const nextName =
          pickStringByPaths(user, [
            "currentCharacter.characterName",
            "data.currentCharacter.characterName",
            "currentCharacter.name",
            "data.currentCharacter.name",
            "characterName",
            "data.characterName",
          ]) ?? DEFAULT_CHARACTER_NAME;

        if (active) {
          setCharacterName(nextName);
        }
      } catch (error) {
        logError(error);
        if (active) {
          setCharacterName(DEFAULT_CHARACTER_NAME);
        }
      }
    })();

    return () => {
      active = false;
    };
  }, []);

  return characterName;
}
